var exports = {
  "an": "ErrorFallback.module__errorFallbackContainer___djBpMk",
  "MU": "ErrorFallback.module__errorFallbackIcon___djBpMk",
  "S6": "ErrorFallback.module__errorFallbackContent___djBpMk",
  "jQ": "ErrorFallback.module__errorFallbackTitle___djBpMk",
  "pF": "ErrorFallback.module__errorFallbackDescription___djBpMk",
  "sM": "ErrorFallback.module__errorFallbackActions___djBpMk",
};

module.exports = exports;
